import { Quote, Star } from "lucide-react";

// Illustrative positioning statements — not attributed to real named individuals.
const STATEMENTS = [
    { body: "Real-estate demand generation works when the campaign is priced on the actual micro-market — not on a city-wide average. That's the core difference Lead Krafts brings.", role: "The Lead Krafts Method" },
    { body: "OTP verification plus AI-based lead qualification compresses the gap between 'lead delivered' and 'buyer picked up the phone' — the two things sales teams actually care about.", role: "Why Verification Matters" },
    { body: "Site-visit rate is the honest signal of lead quality. Everything upstream — creative, targeting, qualification — is optimised against it.", role: "How We Measure Success" },
];

export default function Trust() {
    return (
        <section id="trust" data-testid="trust-section" className="relative py-24 sm:py-32 px-6 sm:px-10 lg:px-16 border-t border-white/5">
            <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 items-center">
                <div className="lg:col-span-5 relative">
                    <div className="aspect-[4/5] relative overflow-hidden">
                        <img
                            src="https://images.unsplash.com/photo-1624555130581-1d9cca783bc0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBkaXZlcnNlJTIwYnVzaW5lc3MlMjBwZW9wbGUlMjBtZWV0aW5nfGVufDB8fHx8MTc4MzQ5MTA3M3ww&ixlib=rb-4.1.0&q=85"
                            alt="Real-estate strategy meeting"
                            className="w-full h-full object-cover grayscale-[20%]"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#050507] via-transparent to-transparent" />
                    </div>
                    <div className="absolute -bottom-6 -right-4 sm:-right-8 bg-[#D4AF37] text-black p-6 max-w-[260px]">
                        <div className="font-serif-display text-2xl leading-tight">Real-estate demand generation</div>
                        <div className="text-xs uppercase tracking-widest mt-2">Delhi NCR · Hyderabad</div>
                    </div>
                </div>

                <div className="lg:col-span-7">
                    <div className="flex items-center gap-3 mb-6">
                        <div className="h-px w-10 bg-[#D4AF37]" />
                        <span className="overline">How We Think About Leads</span>
                    </div>
                    <h2 className="font-serif-display text-4xl sm:text-5xl tracking-tight leading-[1.05]">
                        Verified buyers. <span className="italic text-[#D4AF37]">Better qualification.</span> Smarter targeting.
                    </h2>
                    <div className="mt-10 space-y-6">
                        {STATEMENTS.map((t, i) => (
                            <div key={t.role} data-testid={`statement-${i}`} className="hol-card p-6">
                                <Quote size={18} className="text-[#D4AF37]" strokeWidth={1.5} />
                                <p className="mt-4 text-white/80 leading-relaxed font-body">{t.body}</p>
                                <div className="mt-5 flex items-center justify-between">
                                    <div className="text-xs text-white/50 uppercase tracking-widest">— {t.role}</div>
                                    <div className="flex gap-0.5">
                                        {["s1","s2","s3","s4","s5"].map((s) => (
                                            <Star key={s} size={12} className="text-[#D4AF37] fill-[#D4AF37]" />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <p className="mt-8 text-xs text-white/40 italic">
                        Positioning statements. Verified client testimonials will appear here as engagements go public.
                    </p>
                </div>
            </div>
        </section>
    );
}
